(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const preferenceKey = 'dstrct05:category-filters';
function setCategoryFilters(section, collapsed) {
  const button = section.querySelector('[data-category-filter-toggle]');
  const sidebar = section.querySelector('.catalogue-filter');
  if (!button || !sidebar) return;
  section.dataset.categoryFiltersCollapsed = String(collapsed);
  sidebar.hidden = collapsed;
  const disclosure = sidebar.querySelector('.filter-disclosure');
  if (disclosure) disclosure.open = true;
  button.setAttribute('aria-expanded', String(!collapsed));
  const label = collapsed ? button.dataset.showLabel : button.dataset.hideLabel;
  button.setAttribute('aria-label', label);
  button.title = label;
  button.hidden = false;
}
function initialiseCategoryFilters() {
  let collapsed = false;
  try { collapsed = sessionStorage.getItem(preferenceKey) === 'collapsed'; } catch (_) {}
  document.querySelectorAll('[data-category-filter-section]').forEach(section => setCategoryFilters(section, collapsed));
}
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-category-filter-toggle], .filter-disclosure > summary');
  if (!trigger) return;
  const section = trigger.closest('[data-category-filter-section]');
  if (!section) return;
  event.preventDefault();
  const collapsed = section.dataset.categoryFiltersCollapsed !== 'true';
  setCategoryFilters(section, collapsed);
  try { sessionStorage.setItem(preferenceKey, collapsed ? 'collapsed' : 'expanded'); } catch (_) {}
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseCategoryFilters, {once:true});
else initialiseCategoryFilters();
document.addEventListener('shopify:section:load', initialiseCategoryFilters);

  } catch(e) { console.error(e); }
})();
})();
